import { checkPermission } from "../libs/utils";

export const usePermissions = (
  currentPermissions, isManagerUser = null, isOwner = null
) => {
  const permissionUser = currentPermissions?.permissionUser;

  const isPermissionDeadlines = permissionUser ? checkPermission(
    permissionUser.userPermissions, "7", "78"
  ) : false;

  const isPermissionAsk = permissionUser ? checkPermission(
    permissionUser.userPermissions, "7", "81"
  ) : false;

  let isPermissionFolderStudio;
  let isPermissionSignStudio;

  if (!isOwner) {
    isPermissionFolderStudio = permissionUser ? checkPermission(
      permissionUser.userPermissions, "13", "86"
    ) : false;
    isPermissionSignStudio = permissionUser ? checkPermission(
      permissionUser.userPermissions, "13", "80"
    ) : false;
  } else {
    isPermissionFolderStudio = true;
    isPermissionSignStudio = true;
  }

  const isPermissionSignItem = permissionUser ? checkPermission(
    permissionUser.userPermissions, "15", "10"
  ) : false;

  const isPermissionFolderItem = permissionUser ? checkPermission(
    permissionUser.userPermissions, "7", "86"
  ) : false;

  const isPermissionClientCard = permissionUser ? checkPermission(
    permissionUser.userPermissions, "13", "79"
  ) : false;

  const isPermissionDocumentInvoices = permissionUser ? checkPermission(
    permissionUser.userPermissions, "6", "65"
  ) : false;

  const isPermissionWebUpload = permissionUser ? checkPermission(
    permissionUser.userPermissions, "1", "1"
  ) : false;

  const isPermissionAnalytics = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "21"
  ) : false;

  const isPermissionVolDaffari = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "77"
  ) : false;

  const isPermissionCosti = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "5"
  ) : false;

  const isPermissionFatturato = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "4"
  ) : false;

  const isPermissionImposte = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "6"
  ) : false;

  const isPermissionIncassaSubito = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "62"
  ) : false;

  const isPermissionRegisterRefuse = permissionUser ? checkPermission(
    permissionUser.userPermissions, "3", "19"
  ) : false;

  const isAuthorizationFiscalPermission = permissionUser ? checkPermission(
    permissionUser.userPermissions, "15", "107"
  ) : false;

  const isAuthorizationPermission = permissionUser ? checkPermission(
    permissionUser.userPermissions, "15", "108"
  ) : false;

  const isPermissionsDeadlinesEInvoices = permissionUser ? checkPermission(
    permissionUser.userPermissions, "15", "20"
  ) : false;

  const isUploadMailPermission = permissionUser ? checkPermission(
    permissionUser.userPermissions, "1", "3"
  ) : false;

  let isPermissionCredits;
  let isPermissionRevenues;

  if (!isOwner) {
    isPermissionCredits = permissionUser ? checkPermission(
      permissionUser.userPermissions, "8", "82"
    ) : false;

    isPermissionRevenues = permissionUser ? checkPermission(
      permissionUser.userPermissions, "8", "83"
    ) : false;
  } else {
    isPermissionCredits = true;
    isPermissionRevenues = true;
  }

  let isPermissionStudioUpload;

  if (!isOwner) {
    isPermissionStudioUpload = checkPermission(
      permissionUser?.userPermissions, "14", "85"
    );
  } else {
    isPermissionStudioUpload = true;
  }

  let isPermissionCreateFolders;

  if (!isOwner) {
    isPermissionCreateFolders = permissionUser ? checkPermission(
      permissionUser?.userPermissions, "14", "84"
    ) : false;
  } else {
    isPermissionCreateFolders = true;
  }

  const isPermissionSign = permissionUser ? checkPermission(
    permissionUser.userPermissions, "15", "10"
  ) : false;

  const isPermissionCheckup = permissionUser ? checkPermission(
    permissionUser.userPermissions, "2", "106"
  ) : false;

  return {
    isPermissionDeadlines,
    isPermissionAsk,
    isPermissionFolderStudio,
    isPermissionFolderItem,
    isPermissionSignStudio,
    isPermissionSignItem,
    isPermissionClientCard,
    isPermissionDocumentInvoices,
    isPermissionWebUpload,
    isPermissionAnalytics,
    isPermissionVolDaffari,
    isPermissionCosti,
    isPermissionFatturato,
    isPermissionImposte,
    isPermissionIncassaSubito,
    isPermissionRegisterRefuse,
    isAuthorizationFiscalPermission,
    isAuthorizationPermission,
    isPermissionsDeadlinesEInvoices,
    isUploadMailPermission,
    isPermissionCredits,
    isPermissionRevenues,
    isPermissionStudioUpload,
    isPermissionCreateFolders,
    isPermissionSign,
    isPermissionCheckup
  };
};
